import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';

import styles from '../Components.module.css';

import { CreateGiideErrorType } from '../../types';
import { IState } from '../../graphql/types';

type Props = {
  noShowMaximumReached?: boolean;
  style?: CSSProperties;
};

const CreateGiideError = ({ noShowMaximumReached, style }: Props) => {
  const createGiideError = useSelector<IState, CreateGiideErrorType | null>(
    state => state.createGiideError
  );

  let children;
  switch (createGiideError) {
    case CreateGiideErrorType.maximumReached:
      children = noShowMaximumReached ? null : (
        <div>
          You've reached the maximum limit of giides on your account. Please
          upgrade to create more giides.
        </div>
      );
      break;

    case CreateGiideErrorType.unknown:
      children = (
        <div>
          Something went wrong creating this giide. Please try again later.
        </div>
      );
      break;

    default:
      children = null;
  }

  return (
    <div
      style={style}
      className={[
        styles.createNewGiideButtonError,
        createGiideError !== null && styles.createNewGiideButtonErrorVisible,
      ].join(' ')}
    >
      {children}
    </div>
  );
};

export default CreateGiideError;
